var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('div',{staticClass:"listTit"},[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }